import { Delivery, Discount, GuestCheckoutDiscount, OrderItem } from './order.model';

export class Order {
  public orderID?: number;
  public status?: string;
  public accountID: number;
  public locationID: string;
  public periodID: number;
  public timeslotStart: string;
  public timeslotEnd?: string;
  public notes?: string;
  public discounts?: Discount[] | GuestCheckoutDiscount;
  public subTotal: number;
  public total: number;
  public items: OrderItem[];
  public delivery?: Delivery;
  public firstName?: string;
  public lastName?: string;
  public email?: string;
  public phoneNumber?: string;
}
